import { render } from "./SplashFooter.vue.js?vue&type=template&id=24725528&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashFooter.vue?vue&type=template&id=24725528&scoped=true"
import script from "./SplashFooter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashFooter.vue?vue&type=script&lang=js"
export * from "./SplashFooter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashFooter.vue?vue&type=script&lang=js"

import "./SplashFooter.vue.scss?vue&type=style&index=0&id=24725528&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashFooter.vue?vue&type=style&index=0&id=24725528&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24725528"],['__file',"src/Web/scripts/components/splash/SplashFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24725528"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24725528', __exports__)) {
    api.reload('24725528', __exports__)
  }
  
  module.hot.accept("./SplashFooter.vue.js?vue&type=template&id=24725528&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashFooter.vue?vue&type=template&id=24725528&scoped=true", () => {
    api.rerender('24725528', render)
  })

}


export default __exports__